<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5 22C4.44772 22 4 21.5523 4 21C4 20.4477 4.44772 20 5 20H9.197L12.753 4H9C8.44772 4 8 3.55228 8 3C8 2.44772 8.44772 2 9 2H19C19.5523 2 20 2.44772 20 3C20 3.55228 19.5523 4 19 4H14.802L11.246 20H15C15.5523 20 16 20.4477 16 21C16 21.5523 15.5523 22 15 22H5Z"
    fill="currentColor"
  />
</svg>
